import React from 'react';
import styled from 'styled-components';
import { Body5, Body7 } from '@ui';

// The reasoning behind a score, rendered.
//
// Payload prose is the thing a redesign is most likely to restyle — markdown, truncate-with-expand,
// citations, a copy button — and it was written twice: once in RowPayload's disclosure and once in
// CompanyScoreHistory's occasion list, down to a character-identical stringify fallback. The two are
// never on screen together, so drift between them is invisible.
//
// `maxWidth` is in ch and is a real difference rather than drift: the row disclosure has the table's
// full width to use, the panel is a min(720px, 86vw) dialog.
//
// What this does NOT own is the outer wrapper. RowPayload lays its fields out in a flex column with
// its own gap; CompanyScoreHistory spaces them with Container. Both are legitimate and neither is
// this component's business — it renders one field's label and prose, and the caller places them.
const Prose = styled.div`
  white-space: pre-wrap;
  max-width: ${({ $maxWidth }) => $maxWidth}ch;
`;

// A payload value is whatever the score spec put there. A string is prose and renders as prose;
// anything else is shown as JSON rather than as `[object Object]`, which is what a reader needs in
// order to report that a spec is emitting the wrong shape.
const asText = (value) => (typeof value === 'string' ? value : JSON.stringify(value));

export const PayloadField = ({ entry, maxWidth = 90 }) => (
  <>
    <Body7 bold isLowContrast>
      {entry.label}
    </Body7>
    <Prose $maxWidth={maxWidth}>
      <Body5>{asText(entry.value)}</Body5>
    </Prose>
  </>
);
